import React, { useEffect, useRef, useState } from "react";
import { createCurrency } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { toBase64 } from "../../Services/commonHelper";

const AddCurrency = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: null,
        currency_name: null,
        logo: null,
        unicode_character: null
    });
    const [loader, setLoader] = useState(false);
    const uploadLogoRef = useRef(null);

    const [previewImage, setPreviewImage] = useState({
        logo: "",
        flag: ""
    });

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCurrency(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    useEffect(() => {
        if (data?.data) {
            const { currency_name, scholarship_cutoff, logo, unicode_character, id } = data?.data;
            setReqData({ currency_name, scholarship_cutoff, logo, unicode_character, id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Currency" : "Edit Currency"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Currency Name</label>
                                            <input
                                                required
                                                type="text"
                                                className="form-control"
                                                placeholder="Currency Name"
                                                value={reqData?.currency_name}
                                                onChange={(e) => handleChange("currency_name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Unicode Character</label>
                                            <input
                                                type="url"
                                                className="form-control"
                                                placeholder="Website"
                                                value={reqData?.unicode_character}
                                                onChange={(e) => handleChange("unicode_character", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.logo ? "Change Logo" : "Add Logo"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.logo || reqData?.logo) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.logo ? previewImage?.logo : reqData?.logo}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "logo")} />
        </div>
    );
};

export default AddCurrency;